import { MorgansTypes } from '@mono/proto-clients';
export const LandscapeCriterionKind = MorgansTypes.LandscapeCriterionKind;
export const EMPTY_FORM = {
    name: '',
    scope: '',
    organizations: '',
    capabilities: '',
    context: '',
    observedOnly: false,
    criteria: []
};
export const CRITERION_KINDS = [
    {
        kind: LandscapeCriterionKind.AGENCY,
        label: 'agency'
    },
    {
        kind: LandscapeCriterionKind.NAICS,
        label: 'NAICS'
    },
    {
        kind: LandscapeCriterionKind.PSC,
        label: 'PSC'
    },
    {
        kind: LandscapeCriterionKind.CAPABILITY,
        label: 'capability'
    }
];
export function criterionLabel(kind) {
    return CRITERION_KINDS.find((k)=>k.kind === kind)?.label ?? 'unknown';
}
const splitList = (raw)=>raw.split(',').map((s)=>s.trim()).filter(Boolean);
/** Blank criterion rows are dropped; the server holds the rest verbatim. */ export function toLandscapeInput(form) {
    return {
        name: form.name.trim(),
        scope: form.scope.trim(),
        organizationIds: splitList(form.organizations),
        capabilities: splitList(form.capabilities),
        context: form.context.trim(),
        observedOnly: form.observedOnly,
        criteria: form.criteria.map((c)=>({
                kind: c.kind,
                value: c.value.trim()
            })).filter((c)=>c.value !== '')
    };
}
export function fromLandscape(l) {
    return {
        name: l.name,
        scope: l.scope,
        organizations: l.organizationIds.join(', '),
        capabilities: l.capabilities.join(', '),
        context: l.context,
        observedOnly: l.observedOnly,
        criteria: l.criteria.map((c)=>({
                kind: c.kind,
                value: c.value
            }))
    };
}
